const STATUS_VARIANT = {
    active: 'success',
    inactive: 'default',
    temporary_leave: 'warning',
    approved: 'info',
};
const STATUS_LABEL = {
    active: 'Activo',
    inactive: 'Inactivo',
    temporary_leave: 'Baja temporal',
    approved: 'Aprobado',
};
export function getStatusBadgeVariant(status) {
    return STATUS_VARIANT[status] ?? 'default';
}
export function getStatusLabel(status) {
    return STATUS_LABEL[status] ?? status;
}
//# sourceMappingURL=badge-utils.js.map